export const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '6b880124-8628-4818-a7a2-a86efec55f23',
  REACT_APP_API_URL: 'https://as-mg-tst1-t1-weu-smartinsights-api-01.azurewebsites.net',
  REACT_APP_DOCAI_URL: 'https://as-mg-tst1-t1-weu-docai-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'http://localhost:3000',
  RFP_WRITER_ROLE: 'CD_CP_APP_RFP_WRITER_NPD',
  RFP_ADMIN_ROLE: 'CD_CP_APP_RFP_ADMIN_NPD',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE: 'api://cdc4b066-f7ce-4118-b83a-ed192c48d903/User.Read',
  APP_INSIGHTS_CONNECTION_STR: '***'
}

export const getConfig = () => {
  if (import.meta.env.MODE === 'development') {
    return localConfig
  } else {
    return window.config
  }
}
